import type { DateTime } from "luxon";

/**
 * Fill the gap between two dates with months as the reporting will only return months with values
 *
 * @param min Minimum date
 * @param max Maximum date
 */
export function* fillPeriodGap(min: DateTime, max: DateTime): Generator<DateTime> {
  let cursor = max.endOf("month");
  while (cursor > min) {
    yield cursor;
    cursor = cursor.minus({ months: 1 });
  }
}
